import React, {CSSProperties, ChangeEvent, KeyboardEventHandler, FocusEvent, ReactElement} from 'react'
import LabelComponent from '../LabelComponent/LabelComponent'
import './InputComponent.scss'

export type ITypesInputComponent = 'text' | 'number' | 'date' | 'password' | 'file'
export interface InputComponentProps {
    className?: string
    style?: CSSProperties
    value?: string
    defaultValue?: string
    type?: ITypesInputComponent
    name?: string
    ref?: any
    formHook?: any
    placeholder?: string
    disabled?: boolean
    required?: boolean
    children?: any
    valid?: boolean
    validText?: string
    invalid?: boolean
    invalidText?: string
    label?: string
    id?: string
    min?: string
    max?: string
    accept?: string
    background?: 'background-login' | 'background' | 'background2'
    warningText?: string
    limit?: number
    endIcon?: ReactElement
    onChange?: (e: ChangeEvent<HTMLInputElement>)=>any
    onEnter?: (value?: string)=>any
    onFocus?: (e: FocusEvent<HTMLInputElement>) => any;
    onBlur?: (e: FocusEvent<HTMLInputElement>) => any;
}

interface IInputComponentSubComponents{
    Icon: React.FC<IIconInputProps>
}

const InputComponent: React.FC<InputComponentProps> & IInputComponentSubComponents = (props) => {

    const handleKeyUp = (e: any) => {
        if(props.onEnter){
            if(e.key === 'Enter' || e.keyCode === 13){
                props.onEnter(e.target.value)
            }
        }
    }

    const currentValue = props.formHook?.watch && props.formHook?.watch(props?.name) && typeof props.formHook?.watch(props?.name) === 'string'
      ? props.formHook.watch(props.name)
      : props.value
        ? props.value
        : ''

    return (
        <div>
            {props.label ?
                <LabelComponent>
                    {props.label}
                </LabelComponent>
            :null}
            <div
                className={`input-group input_component-layout ${props.className ? props.className : ''}`}
                style={props.style}
            >
              {props.children}
              <input
                  type={props.type ? props.type : 'text'}
                  className={`form-control ${props.valid ? 'is-valid' : ''} ${props.invalid ? 'is-invalid' : ''} ${props.children ? 'icon-spacing' : ''} ${props.endIcon ? 'input-component--end-icon-space' : ''}`}
                  placeholder={props.placeholder}
                  ref={props.formHook ? props.formHook : props.ref}
                  onChange={props.onChange}
                  name={props.name}
                  value={props.value}
                  defaultValue={props.defaultValue}
                  disabled={props.disabled}
                  required={props.required}
                  id={props.id}
                  onKeyUp={(e) => handleKeyUp(e)}
                  min={props.min || undefined}
                  max={props.max || undefined}
                  onFocus={props.onFocus}
                  onBlur={props.onBlur}
                  accept={props.accept ? props.accept : undefined}
                  style={{
                      backgroundColor: props.background ? `var(--${props.background})` : undefined
                  }}
              />
              {!!props.endIcon && (
                <div className='input-component--end-icon'>
                  {props.endIcon}
                </div>
              )}
              {!!props.limit && (
                <LabelComponent
                  color={currentValue?.length > props.limit ? 'var(--danger)' : 'var(--gray-600)'}
                  marginLeft='auto'
                >
                  {currentValue?.length}/{props.limit}
                </LabelComponent>
              )}
              {props.valid && props.validText ?
                <div className="valid-feedback">
                    {props.validText}
                </div>
              : null}
              {props.invalid && props.invalidText ?
                <div className="invalid-feedback">
                    {props.invalidText}
                </div>
              : null}
              {!!props.warningText && (
                <LabelComponent color='var(--warning)'>
                    {props.warningText}
                </LabelComponent>
              )}
            </div>
        </div>
    );
}

interface IIconInputProps{
    children?: any
    className?: string
    style?: CSSProperties
}

const Icon: React.FC<IIconInputProps> = (props) => {
    return(
        <div className="container_icon-input">
            {props.children}
        </div>
    )
}

InputComponent.Icon = Icon

export default InputComponent;
